
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AddFreelancersToExistingBriefRequest,
  ProposalInformationResponse,
  SkillsResponse,
  SkillsSuggestionsRequest,
  SubmitProposalRequest,
  SubmittedProposalsResponse,
} from '../models';
import {
    AddFreelancersToExistingBriefRequestFromJSON,
    AddFreelancersToExistingBriefRequestToJSON,
    ProposalInformationResponseFromJSON,
    ProposalInformationResponseToJSON,
    SkillsResponseFromJSON,
    SkillsResponseToJSON,
    SkillsSuggestionsRequestFromJSON,
    SkillsSuggestionsRequestToJSON,
    SubmitProposalRequestFromJSON,
    SubmitProposalRequestToJSON,
    SubmittedProposalsResponseFromJSON,
    SubmittedProposalsResponseToJSON,
} from '../models';

export interface AddFreelancersToExistingBriefOperationRequest {
    briefId: string;
    addFreelancersToExistingBriefRequest: AddFreelancersToExistingBriefRequest;
}

export interface FindLatestSubmittedProposalsRequest {
    fromBriefId?: string;
}

export interface GetProposalInformationRequest {
    profileIds?: Array<string>;
    searchId?: string;
    briefId?: string;
}

export interface SigninCallbackRequest {
    briefId: string;
}

export interface SubmitProposalOperationRequest {
    submitProposalRequest: SubmitProposalRequest;
}

export interface SuggestSkillsForProposalRequest {
    skillsSuggestionsRequest: SkillsSuggestionsRequest;
}

/**
 * 
 */
export class SearchProposalApi extends runtime.BaseAPI {

    /**
     * Add new freelancers manually selected or from shortlist to an existing brief, can update brief description if opportunity don\'t already have application
          */
    async addFreelancersToExistingBriefRaw(requestParameters: AddFreelancersToExistingBriefOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling addFreelancersToExistingBrief().'
            );
        }

        if (requestParameters['addFreelancersToExistingBriefRequest'] == null) {
            throw new runtime.RequiredError(
                'addFreelancersToExistingBriefRequest',
                'Required parameter "addFreelancersToExistingBriefRequest" was null or undefined when calling addFreelancersToExistingBrief().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/brief/api/search-proposal/{briefId}/freelancers`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddFreelancersToExistingBriefRequestToJSON(requestParameters['addFreelancersToExistingBriefRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Add new freelancers manually selected or from shortlist to an existing brief, can update brief description if opportunity don\'t already have application
          */
    async addFreelancersToExistingBrief(requestParameters: AddFreelancersToExistingBriefOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.addFreelancersToExistingBriefRaw(requestParameters, initOverrides);
    }

    /**
     * Find latest submitted proposal for the current client identity id or the selected one from the available identities list
          */
    async findLatestSubmittedProposalsRaw(requestParameters: FindLatestSubmittedProposalsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SubmittedProposalsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['fromBriefId'] != null) {
            queryParameters['fromBriefId'] = requestParameters['fromBriefId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SubmittedProposalsResponse>({
            path: `/brief/api/search-proposal/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SubmittedProposalsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Find latest submitted proposal for the current client identity id or the selected one from the available identities list
          */
    async findLatestSubmittedProposals(requestParameters: FindLatestSubmittedProposalsRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SubmittedProposalsResponse> {
        const response = await this.findLatestSubmittedProposalsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get all information to display search proposal page
          */
    async getProposalInformationRaw(requestParameters: GetProposalInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProposalInformationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['profileIds'] != null) {
            queryParameters['profileIds'] = requestParameters['profileIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['searchId'] != null) {
            queryParameters['searchId'] = requestParameters['searchId'];
        }

        if (requestParameters['briefId'] != null) {
            queryParameters['briefId'] = requestParameters['briefId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProposalInformationResponse>({
            path: `/brief/api/search-proposal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProposalInformationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get all information to display search proposal page
          */
    async getProposalInformation(requestParameters: GetProposalInformationRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProposalInformationResponse> {
        const response = await this.getProposalInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Search Proposal Signin Callback
          */
    async signinCallbackRaw(requestParameters: SigninCallbackRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling signinCallback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/brief/search-proposal-signin/{briefId}/submit`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Search Proposal Signin Callback
          */
    async signinCallback(requestParameters: SigninCallbackRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.signinCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * Submit Search Proposal to create the related brief
          */
    async submitProposalRaw(requestParameters: SubmitProposalOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submitProposalRequest'] == null) {
            throw new runtime.RequiredError(
                'submitProposalRequest',
                'Required parameter "submitProposalRequest" was null or undefined when calling submitProposal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/brief/api/search-proposal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitProposalRequestToJSON(requestParameters['submitProposalRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Submit Search Proposal to create the related brief
          */
    async submitProposal(requestParameters: SubmitProposalOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.submitProposalRaw(requestParameters, initOverrides);
    }

    /**
     * Suggest skills from chosen freelancers category and proposal title
          */
    async suggestSkillsForProposalRaw(requestParameters: SuggestSkillsForProposalRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SkillsResponse>> {
        if (requestParameters['skillsSuggestionsRequest'] == null) {
            throw new runtime.RequiredError(
                'skillsSuggestionsRequest',
                'Required parameter "skillsSuggestionsRequest" was null or undefined when calling suggestSkillsForProposal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SkillsResponse>({
            path: `/brief/api/search-proposal/skills/suggestions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SkillsSuggestionsRequestToJSON(requestParameters['skillsSuggestionsRequest']),
        }, initOverrides);

        if (response._data) { response._data=SkillsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Suggest skills from chosen freelancers category and proposal title
          */
    async suggestSkillsForProposal(requestParameters: SuggestSkillsForProposalRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SkillsResponse> {
        const response = await this.suggestSkillsForProposalRaw(requestParameters, initOverrides);
        return response._data;
    }

}
